export default __webpack_public_path__ + "static/media/AvatarDefault.8933784a.png";